import { useId, useState } from 'react';
import { Compass, Pause, Play, Quote } from 'lucide-react';
import './testimonials-with-marquee.css';

export function TestimonialsSection({ title, description, testimonials, eyebrow, id = 'testimonials' }) {
  const [paused, setPaused] = useState(false);
  const headingId = useId();
  return <section id={id} aria-labelledby={headingId} data-testid="home-testimonials" className="testimonials-marquee">
    <div className="testimonials-marquee__heading">
      <div>{eyebrow}<h2 id={headingId}>{title}</h2><p>{description}</p></div>
      <button type="button" className="testimonials-marquee__pause" aria-label={paused ? 'Play Magellan quotes' : 'Pause Magellan quotes'} aria-pressed={paused} onClick={() => setPaused(value => !value)}>
        {paused ? <Play size={16} /> : <Pause size={16} />}
      </button>
    </div>
    <div className="testimonials-marquee__viewport" data-paused={paused} tabIndex={0} aria-label="Magellan perspectives. Hover or focus to pause scrolling.">
      <div className="testimonials-marquee__track">
        {[0, 1].map(copy => <div key={copy} className="testimonials-marquee__group" aria-hidden={copy === 1 ? true : undefined}>
          {testimonials.map((item, index) => <figure key={item.author.handle || index} className="testimonials-marquee__card">
            <Quote className="testimonials-marquee__quote" size={22} strokeWidth={1.3} aria-hidden="true" />
            <blockquote>{item.text}</blockquote>
            <figcaption>
              {item.author.avatar ? <img src={item.author.avatar} alt="" loading="lazy" /> : <span className="testimonials-marquee__brand"><Compass size={23} strokeWidth={1.3} aria-hidden="true" /></span>}
              <span><strong>{item.author.name}</strong><span>{item.author.handle}</span></span>
            </figcaption>
          </figure>)}
        </div>)}
      </div>
    </div>
  </section>;
}
